const styles = {
  container: {
    label: 'DigitalHuman',
    position: 'absolute',
    height: '100%',
    width: '100%',
    '& a, & a:active, & a:focus, & button, & button:active, & button:focus': {
      outline: 'none'
    }
  },
  avatar: {
    label: 'avatar',
    height: '100%',
    width: '100%'
  },
  localVideo: {
    width: 400,
    height: 300,
    display: 'none'
  }
}

export default styles
